import React from 'react';
import { CheckIcon } from 'lucide-react';
import { FadeUp } from './ui/FadeUp';
export function WhySparkHRSection() {
  const differentiators = ['Real HR experts — not chatbots', 'Structured systems instead of reactive HR', 'Fast response times', 'Modern workflows designed for growing companies'];
  return <section id="why" className="py-28 bg-section-lavender" data-id="element-377">
      <div className="max-w-[1240px] mx-auto px-8" data-id="element-378">
        <FadeUp className="text-center mb-16" data-id="element-379">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900" data-id="element-380">
            Why companies choose SparkHR
          </h2>
        </FadeUp>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-6 max-w-4xl mx-auto mb-16" data-id="element-381">
          {differentiators.map((item, index) => <FadeUp key={index} delay={index * 0.1} className="flex items-center gap-4 bg-white p-4 rounded-xl border border-[#eee] shadow-[0_10px_30px_rgba(0,0,0,0.05)]" data-id="element-382">
              <div className="w-8 h-8 rounded-full bg-purple-50 flex items-center justify-center shrink-0" data-id="element-383">
                <CheckIcon className="w-5 h-5 text-purple-500" data-id="element-384" />
              </div>
              <span className="text-lg text-gray-800 font-medium" data-id="element-385">{item}</span>
            </FadeUp>)}
        </div>

        <FadeUp delay={0.4} className="text-center max-w-3xl mx-auto" data-id="element-386">
          <p className="text-2xl md:text-3xl font-medium text-gray-900 leading-tight" data-id="element-387">
            SparkHR combines human expertise with intelligent systems to deliver
            reliable People Operations support.
          </p>
        </FadeUp>
      </div>
    </section>;
}